/**
 * @module builder
 */
import type { OptionsDocument, QuoteDocument, RatesDocument } from 'paintscout'
import type { UpdateableItem, QuoteItemSection } from '../../types'
import type { UpdateableLineItem } from '../../line-items'
import type { UpdateableArea } from '../../areas'
import { updateLineItem } from '../../line-items/update-line-item/update-line-item'
import { updateArea } from '../../areas/update-area/update-area'
import type { UpdateableGroup } from '../../groups'
import { updateGroup } from '../../groups/update-group/update-group'

export function updateItem(args: {
  quote: QuoteDocument
  item: UpdateableItem
  options: OptionsDocument
  /** For the tier swap inside calculateQuote, when this adds an area on a non-base tier. */
  rates?: RatesDocument | null
  calculate?: boolean
  insertBeforeKey?: string
  insertAfterKey?: string
  section?: QuoteItemSection
}): QuoteDocument {
  const { quote, options, rates, item, calculate, insertBeforeKey, insertAfterKey, section } = args

  if (item.type === 'lineItem') {
    return updateLineItem({
      quote,
      options,
      item: item as UpdateableLineItem,
      calculate,
      insertBeforeKey,
      insertAfterKey
    })
  } else if (item.type === 'area') {
    return updateArea({
      quote,
      options,
      rates,
      area: item as UpdateableArea,
      calculate,
      insertBeforeKey,
      insertAfterKey
    })
  } else if (item.type === 'group') {
    return updateGroup({ quote, options, group: item as UpdateableGroup, calculate, section })
  }
  return quote
}
